import gsap from 'gsap';


export default class Blog{
    
    constructor() {
        this.$self = null;
        this._init();
    }


    _init(){
        
        if(document.location.hostname == "localhost"){
            this.COUNTER_API = '/chu5/mvweb_2023/assets/json/good.json';
        }
        else{
            this.COUNTER_API = 'https://library.benesse.ne.jp/bbsui/uiservice/';
        }
        //console.log(this.COUNTER_API);

        this.$main = window.parent.document.querySelector('.l-main');
        this.$self = document.querySelector('.blog');
        this.$good = document.querySelector('.js-blog-good');
        this.$count = document.querySelector('.blog__good__count');
        this.$prev = document.querySelector('.blog__nav__item.-prev');
        this.$next = document.querySelector('.blog__nav__item.-next');

        this.gakunen = this.$main.getAttribute('data-gakunen');
        this.page = this.$main.getAttribute('data-page');

        this.blogId = this.$self.getAttribute('id');
        this.cmtId = this.$self.getAttribute('data-goodid');
        this.btnCnt = 'BtnCnt1';
        this.likes = this._getGoodStorage();
        this.archives = [...document.querySelectorAll('.blog__archives li')];

        if(this.cmtId){
            this._connect();
            this._checkAlreadyGood();
        }
        else{
            this.$count.innerHTML = 0;
        }
        
        this._checkBodyLink();
        this._checkNew();

        window.addEventListener('scroll', ()=>{
            this._onScroll();
        });
        this._onScroll();

        if(this.page!='nanchu' && this.page!='otayori'){
            this._settingPager();
        }
    }


    /**
     * スクロールイベント
     */
    _onScroll(){
    }


    /**
     * New マーク
     */
    _checkNew(){
        const fromDate = new Date(this.$self.getAttribute('data-entrydate'));
        const toDate = new Date();
        const ms = toDate.getTime() - fromDate.getTime();
        const days = Math.floor(ms / (1000*60*60*24));
        
        if(days <= 14){
            document.querySelector('.blog__new').classList.add('-active');
        }
    }

    
    /**
     * イイねボタン
     */
    _connect(){
        const send = {CmtSelect: [{ ThmId:'count_mvw', DspStrtLoc:1, DspLin: 9999}]};

        // テスト用
        //const send = {CmtSelect: [{ ThmId:'count_c', DspStrtLoc:1, DspLin: 9999}]};
        //this.cmtId = 21071513;

        const jsonData = {json: JSON.stringify(send)};

        $.ajax({
            url: this.COUNTER_API,
            type: 'POST',
            data: jsonData,
            dataType: 'json',
            success: (data)=>{
                this._onSuccess(data);

                this.$good.addEventListener('click', ()=>{
                    if(this.likes.indexOf(this.blogId) > -1) return;
                    this._onCountUp();
                });
            },
            error: ()=> {
            },
        });
    }

    _onSuccess(data){
        console.log(data);

        const counter = {};

        // 該当のCmtIdを持つコメントを取得
        data.CmtSelect[0].CmtList.some(elm => {
            counter.count = 0;
            
            if(elm.CmtId == this.cmtId){
                counter.count = elm[this.btnCnt];

                let _Cmt = JSON.parse(elm.Cmt);
                counter.adjustment = _Cmt[this.btnCnt].adjustment;
                return true;
            }
        });

        // 増減が設定されていたら反映
        if(counter.adjustment){
            counter.count += parseInt(counter.adjustment);
        }

        this.$count.innerHTML = counter.count;
    }

    _onCountUp(){

        // データ送信
        const submit = { BtnCntInsert: [{ ThmId:'count_mvw', CmtId:this.cmtId, BtnId:"1" }] };
        const submitJson = { json: JSON.stringify(submit) };
        $.ajax({
            url: this.COUNTER_API,
            type: 'POST',
            data: submitJson,
            dataType: 'json',
        })
        .done((data)=>{
        });

        // カウント表示を1増やす
        const count = parseInt(this.$count.textContent);
        this.$count.innerHTML = count+1;

        // ストレージに保存
        if(!this.$good.classList.contains('-active')) {
            this._saveGoodStorage(this.blogId);
        }

        gsap.killTweensOf(this.$good);
        gsap.to(this.$good, {duration:0.15, scale:1.5, yoyo:true, repeat:1, ease:'power2.out', onComplete:()=>{
            this.$good.removeAttribute('style');
        }});

        this.$good.classList.add('-active');
    }

    _getGoodStorage(){
        return parent.window.DATA.getData('likes');
    }

    _saveGoodStorage(key){
        this.likes.push(key);
        parent.window.DATA.setData('likes', this.likes);
    }

    _checkAlreadyGood(){

        if(this.likes.indexOf(this.blogId) > -1){
            this.$good.classList.add('-active');
        }
    }


    /**
     * 外部リンクの設定
     */
    _checkBodyLink(){
        const links = [...document.querySelectorAll('.blog__main a')];

        links.forEach(($a)=>{

            if($a.getAttribute('target') != '_blank'){
                $a.setAttribute('target', '_parent');
            }
        });
    }


    /**
     * ページャー設定
     */
    _settingPager(){
        const ary = [];
        let idx = 0;

        const $prevA = this.$prev.querySelector('a');
        const $nextA = this.$next.querySelector('a');

        this.archives.forEach($el=>{

            if($el.classList.contains(this.gakunen)){
                ary.push($el);
                
                const id = $el.getAttribute('data-entryid');
                if(id == this.blogId) idx = ary.length-1;
            }
        });

        if(ary.length > 1){
            
            if(idx == 0){
                $nextA.setAttribute('href', ary[idx+1].getAttribute('data-url'));
                this.$prev.classList.add('-disable');
            }
            else if(idx >= ary.length-1){
                $prevA.setAttribute('href', ary[idx-1].getAttribute('data-url'));
                this.$next.classList.add('-disable');
            }
            else{
                $prevA.setAttribute('href', ary[idx-1].getAttribute('data-url'));
                $nextA.setAttribute('href', ary[idx+1].getAttribute('data-url'));
            }
        }
        else{
            this.$prev.classList.add('-disable');
            this.$next.classList.add('-disable');
        }
    }
}